/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState, useEffect, useContext } from 'react';
import { NotificationsActive, Notifications, ArrowBackIos, Mail } from '@material-ui/icons';
import {
  Badge, IconButton, Menu, MenuItem,
  Typography, Divider, Button, Collapse, Zoom, CircularProgress, makeStyles
} from '@material-ui/core';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { AppContext, AuthContext } from 'Context';
import useSWR from 'swr';
import { dataFetcher, endpoints, axios } from 'Api';
import { Pathname } from 'Routes';
import { ref, off, onValue } from 'firebase/database';
import { Snackbar } from '../../snackbar';
import styles from './NotificationsClassic.module.css';
import UserRequest from './UserRequest';

const transitionTimeout = 300;

const useStyles = makeStyles({
  customWidth: {
    '& .MuiPaper-root': {
      minWidth: '500px',
      maxWidth: '500px',
      borderRadius: '20px',
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.15)',
      overflow: 'visible',
      border: '1px solid rgba(0, 0, 0, 0.1)',
      background: '#ffffff',
      '&::-webkit-scrollbar': {
        display: 'none'
      }
    }
  }
});

const defaultProps = {
  color: 'secondary',
  children: <Notifications
    fontSize="large"
  />
};
export default function NotificationsClassic({ handlePushNotification, getUserConnections,
  updateNotificationStatus, clearing, setClearing }) {
  const { langText, setViewerListUpdate, firebaseDatabase, autoSignIn } = useContext(AppContext);
  const { isInActiveUser } = useContext(AuthContext);
  const location = useLocation();
  const navigate = useNavigate();
  const classes = useStyles();
  const notificationText = langText?.header;
  const [newNotification, setNewNotification] = useState(0);
  const [notificationNewRequestData, setNotificationNewRequestData] = useState([]);
  const [notificationsData, setNotificationsData] = useState([]);
  const [deletingIds, setDeletingIds] = useState(new Set());

  const [notificationsMoreAnchorEl, setMobileMoreAnchorEl] = useState(null);
  const isNotificationMenuOpen = Boolean(notificationsMoreAnchorEl);
  const [accessRequests, setAccessRequests] = useState([]);
  const [snackbar, setSnackbar] = useState({ isVisible: false, message: '' });
  const [invitations, setInvitations] = useState([]);
  const [deleting, setDeleting] = useState(false);

  const { isValidating: loadingAccessRequests, mutate: fetchAccessRequests } = useSWR(endpoints.getAllViewRequest, {
    onSuccess: ({ success, data }) => {
      if (success && data) {
        setAccessRequests(data?.filter(({ status }) => (status === '0')));
      } else {
        setAccessRequests([]);
      }
    },
    onError: () => {
      setAccessRequests([]);
    },
  });

  const { isValidating: loadingInvitations, mutate: fetchInvitations } = useSWR(endpoints.getAllViewRequestSent, {
    onSuccess: ({ success, data }) => {
      if (success && data) {
        setInvitations(data?.filter(({ status }) => (status === '3')));
      } else {
        setInvitations([]);
      }
    },
    onError: () => {
      setInvitations([]);
    },
  });
  const handleNotificationMenuClose = () => {
    setMobileMoreAnchorEl(null);
  };
  const handleNotificationMenuOpen = (event) => {
    setNewNotification(0);
    setMobileMoreAnchorEl(event.currentTarget);
    updateNotificationStatus('', true);
  };

  const { isValidating: gettingMyNotifications, mutate: getMyNotifications } = useSWR([
    endpoints.getMyNotifications
  ], {
    fetcher: (url) => dataFetcher(url),
    onSuccess: ({ success, data, total_count, unread_count }) => {
      if (success) {
        getUserConnections();
        setNotificationsData(data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at)));
        if (unread_count > 0) {
          setNewNotification(unread_count);
        } else {
          setNewNotification(0);
        }
        setDeleting(false);
        setClearing(false);
      }
    },
    onError: (err) => {
      setDeleting(false);
      // reload page if invalid token
      if (parseInt(err?.response?.status, 10) === 401) {
        window.location.reload();
      }
    },
  });

  const deleteAllNotifications = async () => {
    setDeleting(true);
    await axios
      .post(endpoints.deleteAllMyNotifications)
      .then(({ success }) => {
        setDeleting(false);
        setClearing(false);
        setNotificationsData([]);
        getMyNotifications();
        // if (success) {
        // }
      })
      .catch((error) => {
        getMyNotifications();
        setDeleting(false);
        setClearing(false);
      });
  };

  useEffect(() => {
    if (isNotificationMenuOpen) {
      getMyNotifications();
      fetchAccessRequests();
      fetchInvitations();
    }
  }, [isNotificationMenuOpen]);

  useEffect(() => {
    if (!localStorage.getItem('id')) {
      autoSignIn();
    } else {
      const databaseRefGetMyNotifications = ref(firebaseDatabase, `notifications_updates/${localStorage.getItem('id')}`);
      const databaseRefFetchRequests = ref(firebaseDatabase, `friend_requests_updates/${localStorage.getItem('id')}`);
      const databaseRefFetchTempRequests = ref(firebaseDatabase, `temp_requests_updates/${localStorage.getItem('id')}`);
      const dataCallbackNoti = (snapshot) => {
        if (snapshot.exists()) {
          getMyNotifications();
        }
      };
      const dataCallbackReq = (snapshot) => {
        if (snapshot.exists()) {
          getUserConnections();
        }
      };
      const dataCallbackTempReq = (snapshot) => {
        if (snapshot.exists()) {
          fetchInvitations();
        }
      };
      onValue(databaseRefGetMyNotifications, dataCallbackNoti);
      onValue(databaseRefFetchRequests, dataCallbackReq);
      onValue(databaseRefFetchTempRequests, dataCallbackTempReq);
      return () => {
        off(databaseRefGetMyNotifications, 'value', dataCallbackNoti);
        off(databaseRefFetchRequests, 'value', dataCallbackReq);
        off(databaseRefFetchTempRequests, 'value', dataCallbackTempReq);
      };
    }
  }, []);

  // const MINUTE_MS = 10000;
  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     fetchAccessRequests();
  //     fetchInvitations();
  //   }, MINUTE_MS);
  //   return () => clearInterval(interval);
  //   // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
  // }, []);

  useEffect(() => {
    if (accessRequests?.length) {
      setViewerListUpdate(true);
    }
  }, [accessRequests]);
  const getNotificationIcon = (message, type) => {
    const lowerMessage = message?.toLowerCase() || '';

    // Check for payment/purchase related notifications
    if (lowerMessage.includes('payment')
      || lowerMessage.includes('purchase')
      || lowerMessage.includes('subscription')
      || lowerMessage.includes('plan')
      || lowerMessage.includes('billing')
      || lowerMessage.includes('paid')
      || type === 'payment'
      || type === 'purchase') {
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13.41 18.09V20H10.74V18.07C9.03 17.71 7.58 16.61 7.5 14.67H9.43C9.53 15.82 10.29 16.69 12.09 16.69C13.99 16.69 14.43 15.75 14.43 15.12C14.43 14.34 14.08 13.53 11.98 13.05C9.58 12.5 7.5 11.55 7.5 9.27C7.5 7.53 8.82 6.43 10.74 6.05V4H13.41V6.02C15.27 6.42 16.2 7.73 16.26 9.33H14.33C14.28 8.26 13.71 7.45 12.09 7.45C10.55 7.45 9.77 8.16 9.77 9.15C9.77 9.93 10.32 10.54 12.38 11.07C14.44 11.6 16.7 12.42 16.7 15.06C16.69 16.88 15.46 17.75 13.41 18.09Z" fill="#5aa5ef" />
        </svg>
      );
    }

    // Check for video related notifications
    if (lowerMessage.includes('video')
      || lowerMessage.includes('upload')
      || lowerMessage.includes('processing')
      || lowerMessage.includes('published')
      || lowerMessage.includes('stream')
      || type === 'video') {
      return (
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
          <path d="M17 10.5V7C17 6.45 16.55 6 16 6H4C3.45 6 3 6.45 3 7V17C3 17.55 3.45 18 4 18H16C16.55 18 17 17.55 17 17V13.5L21 17.5V6.5L17 10.5Z" fill="#5aa5ef" />
        </svg>
      );
    }

    // Default to bell icon for general notifications
    return (
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
        <path d="M12 2C10.9 2 10 2.9 10 4C10 4.3 10.1 4.6 10.2 4.9C7.2 5.8 5 8.6 5 12V17L3 19V20H21V19L19 17V12C19 8.6 16.8 5.8 13.8 4.9C13.9 4.6 14 4.3 14 4C14 2.9 13.1 2 12 2ZM12 23C13.1 23 14 22.1 14 21H10C10 22.1 10.9 23 12 23Z" fill="#5aa5ef" />
      </svg>
    );
  };

  const renderNotificationMenu = (
    <Menu
      anchorEl={notificationsMoreAnchorEl}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      // keepMounted
      transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      open={isNotificationMenuOpen}
      onClose={handleNotificationMenuClose}
      className={classes.customWidth}
      PopoverClasses={{ paper: styles.notificationAnimation }}
      MenuListProps={{
        style: { padding: 0 }
      }}
    >
      {
        [
          <div className={styles.notificationDropDown}>
            <div className={styles.notificationHeader}>
              <div className={styles.notificationHeaderLeft}>
                <Typography className={styles.notfHeading} variant="h6" color="primary">
                  {notificationText?.notification || 'Notifications'}
                </Typography>
              </div>
              {/* <div className={styles.notficatonIcon}>
                <Badge
                  badgeContent={newNotification}
                  {...defaultProps}
                />
              </div> */}
            </div>
            <hr className={styles.dividerAlign} />
            <div className={styles.notificationContainer}>
              {
                !isInActiveUser ? (
                  <>
                    <div>
                      {
                        accessRequests.length > 0 && (
                          <div style={{ padding: '12px 20px 8px 20px' }}>
                            <Typography className={styles.invitationHeading} variant="subtitle2" color="primary">
                              {notificationText?.requests || 'Requests'}
                            </Typography>
                          </div>
                        )
                      }
                      <div>
                        {accessRequests?.map(({ id, firstname, lastname, email }, idx) => (
                          <UserRequest
                            email={email}
                            id={id}
                            key={idx}
                            firstname={firstname}
                            lastname={lastname}
                            setSnackbar={setSnackbar}
                            fetchAccessRequests={fetchAccessRequests}
                            setAccessRequests={setAccessRequests}
                            accessType="request"
                          />
                        ))}
                      </div>
                    </div>
                    <div className={styles.divSpace}>
                      {
                        invitations.length > 0 && (
                          <div style={{ padding: '0 20px' }}>
                            <Typography className={styles.invitationHeading} variant="subtitle2" color="primary">
                              {notificationText?.invitations || 'Invitations'}
                            </Typography>
                          </div>
                        )
                      }
                      <div>
                        {invitations?.map(({ id, firstname, lastname, email }, idx) => (
                          <UserRequest
                            email={email}
                            id={id}
                            key={idx}
                            firstname={firstname}
                            lastname={lastname}
                            setSnackbar={setSnackbar}
                            setAccessRequests={setInvitations}
                            fetchInvitations={fetchInvitations}
                            accessType="invitation"

                          />
                        ))}
                      </div>
                    </div>
                  </>
                ) : isInActiveUser && (invitations.length || accessRequests.length) ? (
                  <>
                    <div style={{ padding: '0 20px', marginBottom: '12px' }}>
                      <div
                        style={{
                          borderLeft: '3px solid #e53e3e',
                          padding: '12px 16px',
                          borderRadius: '8px',
                          background: 'rgba(255, 255, 255, 0.4)',
                          backdropFilter: 'blur(20px) saturate(150%)',
                          WebkitBackdropFilter: 'blur(20px) saturate(150%)',
                          color: '#e53e3e',
                          fontSize: '13px',
                          fontFamily: '"Poppins", sans-serif',
                          lineHeight: '1.6',
                          border: '1px solid rgba(0, 0, 0, 0.08)',
                          textShadow: 'none'
                        }}
                      >
                        Invitation/Request actions are not available for inactive users
                      </div>
                    </div>
                    <div className={styles.updatePaymentButton} onClick={() => navigate(Pathname.getSettingsPath(Pathname.settings.billings))}>
                      Update payment method
                    </div>
                  </>
                ) : null
              }
              {
                gettingMyNotifications && !notificationsData.length && isNotificationMenuOpen ? (
                  <div className={styles.loaderDiv}>
                    <CircularProgress style={{ color: '#5aa5ef' }} />
                  </div>
                ) : notificationsData.length > 0 && (
                  <div className={styles.divSpace}>
                    <div className={styles.headingSpace}>
                      <Typography className={styles.invitationHeading} variant="subtitle2" color="primary">
                        {notificationText?.general || 'General'}
                      </Typography>
                      <Button
                        className={styles.clearAllIcon}
                        onClick={() => {
                          // Optimistic update - clear all from UI immediately
                          setNotificationsData([]);
                          // Then call API
                          deleteAllNotifications();
                        }}
                        size="small"
                      >
                        {notificationText?.clearAll || 'Clear All'}
                      </Button>
                    </div>
                    {notificationsData?.filter(({ id }) => !deletingIds.has(id)).map(({ id, message, type }, index) => (
                      <div key={index} className={styles.generalMessageWrapper}>
                        <div className={styles.generalMessageContent}>
                          <div className={styles.generalMessageIcon}>
                            {getNotificationIcon(message, type)}
                          </div>
                          <div className={styles.generalMessage}>
                            {message}
                          </div>
                        </div>
                        <Button
                          className={styles.clearIconButton}
                          onClick={() => {
                            // Mark as deleting immediately
                            setDeletingIds((prev) => new Set([...prev, id]));
                            // Call API in background - don't care about success/failure
                            updateNotificationStatus(id, 2);
                          }}
                        >
                          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                            <circle cx="12" cy="12" r="10" opacity="0.2" fill="currentColor" />
                            <line x1="15" y1="9" x2="9" y2="15" />
                            <line x1="9" y1="9" x2="15" y2="15" />
                          </svg>
                        </Button>
                      </div>
                    ))}
                  </div>
                )
              }
              {
                !isInActiveUser && accessRequests.length === 0 && invitations.length === 0 && notificationsData.length === 0 && (
                  <div style={{
                    textAlign: 'center',
                    padding: '40px 20px',
                    color: '#718096'
                  }}
                  >
                    <div style={{
                      fontSize: '48px',
                      marginBottom: '16px',
                      opacity: '0.5'
                    }}
                    >
                      🔔
                    </div>
                    <div style={{
                      fontSize: '16px',
                      fontWeight: '600',
                      color: '#4a5568',
                      marginBottom: '8px',
                      fontFamily: '"Poppins", sans-serif'
                    }}
                    >
                      No notifications
                    </div>
                    <div style={{
                      fontSize: '14px',
                      color: '#a0aec0',
                      fontFamily: '"Poppins", sans-serif'
                    }}
                    >
                      You&apos;re all caught up!
                    </div>
                  </div>
                )
              }
            </div>
          </div>
        ]
      }
    </Menu>
  );

  // useEffect(() => {
  //   if (notificationsData.length > 0) {
  //     const newData = notificationsData.filter((x) => x.status === '1');
  //     setNewNotification(newData.length);
  //     // newData.map((x) => (handlePushNotification(x)));
  //   } else {
  //     setNewNotification(0);
  //   }
  // }, [notificationsData]);
  return (
    <>
      {/* {(notificationsData.length > 0 || accessRequests.length > 0 || invitations.length > 0)
        && ( */}
      <IconButton
        className={styles.uploadButton}
        aria-label="show more"
        aria-haspopup="true"
        onClick={handleNotificationMenuOpen}
        color="inherit"
      >
        {' '}
        <Badge className={styles.notificationIcon} badgeContent={newNotification} color="secondary">
          <Notifications
            fontSize="large"
            className={styles.notificationIconHover}
          />
          {/* <Notifications /> */}
        </Badge>
      </IconButton>
      {/* )} */}
      {renderNotificationMenu}
      <Snackbar {...snackbar} onClose={() => { setSnackbar({ ...snackbar, isVisible: false }); }} />
    </>
  );
}
